import { Box, Button, IconButton, Menu, Divider, Drawer, Toolbar, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import TextView from '../../Components/UI/TextView/TextView'
import { getAppointmentCountDetail, getCollectionData } from '../../connections/getApi';
import dateTotal from "../../assets/dateTotal.svg";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from 'react-router-dom';
import UseFetchAppointmentCount from '../../helper/UseFetchAppointmentCount';
import UseFetchUpcomingholidays from '../../helper/UseFetchUpcomingholidays';
import { logout } from '../../redux/slices/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CustomModal from '../../Components/CustomModal/CustomModal';
import AppointmentDetail from '../../Components/ModalChildren/AppointmentDetail';
import rupee from "../../assets/rupee.svg";
import DailyCollectionBilling from '../../Components/ModalChildren/DailyCollectionBilling';
import { Menu as MenuIcon } from "@mui/icons-material";
import logo from "../../assets/logo_sq.svg";
import useOrgName from "../../helper/useOrgName";


const BillingNavbar = () => {
    const isMdUp = useMediaQuery("(min-width:950px)");

    const [mobileOpen, setMobileOpen] = useState(false);
    const toggleMobileMenu = () => setMobileOpen(!mobileOpen);
    const [appointmentType, setAppointmentType] = useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [appointments, setAppointments] = useState([]);
    const [dailyCollection, setDailyCollection] = useState([]);
    const [openDailyCollection, setOpenDailyCollection] = useState(false);
    const appointmentPage = 1;
    const appointmentPerPage = 10;

    const authState = useSelector((state) => state.auth);
    const orgName = useOrgName();

    const handleGetAppointmentDetail = async (value) => {
        const res = await getAppointmentCountDetail(appointmentPage, appointmentPerPage, value);
        if (res.status?.status === "SUCCESS") {
            setAppointmentType(value);
            setAppointments(res?.payload?.appointments);
            setAppointmentType(value);
        }
    };

    const { data: countData } = UseFetchAppointmentCount();
    const { data: holidays } = UseFetchUpcomingholidays();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleGetCollections = async () => {
        const data = await getCollectionData();
        setDailyCollection(data?.payload?.invoices);
        setOpenDailyCollection(true);
    };

    const StatCard = ({ icon, title, value, bg, onClick }) => (
        <Box
            onClick={onClick}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                p: "12px",
                borderRadius: "14px",
                border: "1px solid #E1E1E1",
                cursor: "pointer",
            }}
        >
            {/* ICON */}
            <Box
                sx={{
                    width: 42,
                    height: 42,
                    borderRadius: "10px",
                    backgroundColor: bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {icon}
            </Box>

            {/* TEXT */}
            <Box display="flex" flexDirection="column">
                <TextView
                    fontSize="13px"
                    fontWeight={500}          // ✅ increased
                    sx={{ color: "#6c757d", mb: "4px" }}  // ✅ 4px gap
                >
                    {title}
                </TextView>

                <TextView
                    fontSize="18px"
                    fontWeight={600}
                >
                    {value}
                </TextView>
            </Box>
        </Box>
    );

    const MobileBillingContent = ({ onClose }) => {
        const { data: countData } = UseFetchAppointmentCount();
        const { data: holidays } = UseFetchUpcomingholidays();

        return (
            <Box display="flex" flexDirection="column" gap={2}>
                {/* HEADER */}
                <TextView fontSize="18px" fontWeight={600}>
                    Appointments
                </TextView>

                {/* STATS */}
                <StatCard
                    title="Total Appointments"
                    value={" " + countData?.total || 0}
                    bg="#FFE7DC"
                    icon={<img src={dateTotal} alt="" width={22} />}
                    onClick={onClose}
                />

                <StatCard
                    title="Confirmed"
                    value={countData?.confirmed || 0}
                    bg="#EAF2F4"
                    icon={<CheckIcon sx={{ color: "#21C0A6" }} />}
                    onClick={onClose}
                />

                <StatCard
                    title="Cancelled"
                    value={countData?.cancelled || 0}
                    bg="#FF392B40"
                    icon={<CloseIcon sx={{ color: "#FF392B" }} />}
                    onClick={onClose}
                />

                <StatCard
                    title="Collection"
                    value={countData?.collection || 0}
                    bg="#0067FF40"
                    icon={<img src={rupee} alt="" width={22} />}
                    onClick={onClose}
                />

                {/* HOLIDAYS */}
                {holidays?.holidays?.length > 0 && (
                    <>
                        <Divider />
                        <TextView fontSize="16px" fontWeight={600}>
                            Upcoming Holidays
                        </TextView>

                        {holidays.holidays.slice(0, 2).map((holiday, index) => (
                            <Box
                                key={index}
                                sx={{
                                    backgroundColor: "#FFE7DC",
                                    p: 1.5,
                                    borderRadius: "12px",
                                }}
                            >
                                <TextView fontSize="12px">Holiday</TextView>
                                <TextView fontSize="13px" fontWeight={500}>
                                    {holiday.date} - {holiday.end_date}
                                </TextView>
                                <TextView fontSize="13px" sx={{ color: "#f58633" }}>
                                    {holiday.details}
                                </TextView>
                            </Box>
                        ))}
                    </>
                )}
            </Box>
        );
    };

    return (
        <>
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", p: 0, m: 0, gap: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {/* /* MOBILE BURGER */}
                    {!isMdUp &&
                        (<IconButton onClick={toggleMobileMenu}>
                            <MenuIcon sx={{ color: 'black', height: '1.5rem', width: '1.5rem' }} />
                        </IconButton>)}

                    {/* LEFT - LOGO */}
                    <Box display="flex" alignItems="center">
                        <img src={logo} alt="logo" style={{ width: "3.5rem" }} />
                    </Box>
                </Box>

                {isMdUp && <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        color: "black",
                        justifyContent: "space-between",
                        width: "100%",
                        marginLeft: "2rem",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#FFFFFF",
                                    border: '2px solid #E1E1E1',
                                    borderRadius: "16PX",
                                    paddingX: "15px",
                                    paddingY: "15PX",
                                    marginLeft: "8px",
                                }}
                                onClick={() => handleGetAppointmentDetail("all")}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: "#FFE7DC",
                                        width: "45px",
                                        height: "45px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img src={dateTotal} alt="" width={"28px"} />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        backgroundColor: "#FFFFFF",
                                    }}
                                >
                                    <TextView
                                        fontWeight={400}
                                        fontSize={"14px"}
                                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                                    >
                                        Total Appointments
                                    </TextView>
                                    <TextView
                                        fontSize={"20px"}
                                        fontWeight={"600"}
                                        variant={"h5"}
                                        sx={{ mx: 2 }}
                                    >
                                        {countData?.total || 0}
                                    </TextView>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#FFFFFF",
                                    border: '2px solid #E1E1E1',
                                    borderRadius: "16PX",
                                    paddingX: "15px",
                                    paddingY: "15PX",
                                    marginLeft: "8px",
                                }}
                                onClick={() => handleGetAppointmentDetail("confirmed")}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: "#EAF2F4",
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CheckIcon width={"28px"} sx={{ color: "#21C0A6" }} />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        backgroundColor: "#FFFFFF",
                                    }}
                                >
                                    <TextView
                                        fontWeight={400}
                                        fontSize={"14px"}
                                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                                    >
                                        Confirmed Appointments
                                    </TextView>
                                    <TextView
                                        fontSize={"20px"}
                                        fontWeight={"600"}
                                        variant={"h5"}
                                        sx={{ mx: 2 }}
                                    >
                                        {countData?.confirmed || 0}
                                    </TextView>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#FFFFFF",
                                    border: '2px solid #E1E1E1',
                                    borderRadius: "16PX",
                                    paddingX: "15px",
                                    paddingY: "15PX",
                                    marginLeft: "8px",
                                }}
                                onClick={() => handleGetAppointmentDetail("cancelled")}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: "#FF392B40",
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <CloseIcon width={"28px"} sx={{ color: "#FF392B" }} />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        backgroundColor: "#FFFFFF",
                                    }}
                                >
                                    <TextView
                                        fontWeight={400}
                                        fontSize={"14px"}
                                        sx={{ mx: 2, color: "#3A3A3A", marginBottom: "3px" }}
                                    >
                                        Cancelled Appointments
                                    </TextView>
                                    <TextView
                                        fontSize={"20px"}
                                        fontWeight={"600"}
                                        variant={"h5"}
                                        sx={{ mx: 2 }}
                                    >
                                        {countData?.cancelled || 0}
                                    </TextView>
                                </Box>
                            </Box>


                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    backgroundColor: "#FFFFFF",
                                    border: '2px solid #E1E1E1',
                                    borderRadius: "16PX",
                                    paddingX: "15px",
                                    paddingY: "15PX",
                                    marginLeft: "8px",
                                }}
                                onClick={handleGetCollections}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: "#0067FF40",
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img
                                        src={rupee}
                                        width={"28px"}
                                        sx={{ color: "#21C0A6" }}
                                        alt="rupee"
                                    />
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        backgroundColor: "#FFFFFF",
                                    }}
                                >
                                    <TextView
                                        fontSize={"14px"}
                                        sx={{ mx: 2, color: "#3A3A3A" }}
                                    >
                                        Collections
                                    </TextView>
                                    <TextView
                                        fontSize={"20px"}
                                        fontWeight={"600"}
                                        variant={"h6"}
                                        sx={{ mx: 2 }}
                                    >
                                        {countData?.collections || 0}
                                    </TextView>
                                </Box>
                            </Box>
                        </>

                        {/* <Button
                       onClick={handleAppointmentStatusOpen}
                       variant="contained"
                       color="primary"
                       sx={{
                         background: "#64b5f6",
                         borderRadius: "9px",
                         padding: "8px",
                         ml: "2rem",
                         mt: "auto",
                         "&:hover": {
                           backgroundColor: "#64b349ef35f6",
                         },
                       }}
                     >
                       <TextView variant={"p"} fontSize={"0.6rem"} color={"white"}>
                         Future Appointments
                       </TextView>
                     </Button> */}
                    </Box>

                    <Box
                        sx={{ display: "flex", justifyContent: "center", gap: "10px" }}
                    >
                        {holidays?.holidays?.length > 0 &&
                            holidays.holidays.slice(0, 2).map((holiday, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                        padding: "10px 10px",
                                        borderRadius: "15px",
                                        backgroundColor: "#FFE7DC",
                                    }}
                                >
                                    <TextView
                                        fontSize="0.70rem"
                                        sx={{ mx: 2, color: "#3A3A3A" }}
                                    >
                                        Holiday
                                    </TextView>
                                    <TextView
                                        fontWeight={400}
                                        fontSize="0.87rem"
                                        sx={{ mx: 2 }}
                                    >
                                        {holiday.date} - {holiday.end_date}
                                    </TextView>
                                    <TextView
                                        fontSize="0.87rem"
                                        sx={{ mx: 2, color: "#f58633" }}
                                    >
                                        {holiday.details}
                                    </TextView>
                                </Box>
                            ))}
                    </Box>
                </Box>
                }

                <Box>
                    <IconButton onClick={handleMenuOpen} color="black">
                        {/* <AccountCircleIcon sx={{ height: "2.5rem", width: "3rem" }} /> */}
                        <AccountCircleIcon sx={{ height: "3rem", width: "3rem", color: 'black' }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        sx={{
                            marginLeft: "2.5rem",
                            marginTop: "-0.5rem",
                            "& .MuiPaper-root": {
                                borderRadius: "12px",
                                // padding: "16px",
                                minWidth: "180px",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "3px",
                                p: 2,
                            }}
                        >
                            {orgName && (
                                <Box
                                    sx={{
                                        fontFamily: "Lato",
                                        fontWeight: 700,
                                        fontSize: "0.95rem",
                                        marginBottom: "2px",
                                        color: "neutral.navyBlue",
                                    }}
                                >
                                    {orgName}
                                </Box>
                            )}
                            <Box sx={{ fontWeight: "", fontFamily: "Outfit" }}>{authState?.first_name} </Box>

                            <Box
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    fontFamily: "sans-serif",
                                }}
                            >
                                {authState?.user}
                            </Box>

                            <Box sx={{ marginTop: "5px", fontSize: "0.87rem" }}>
                                {authState?.email}
                            </Box>

                            <Button
                                //  style={{border :'2px solid black'}}
                                disableRipple
                                startIcon={
                                    <LogoutOutlinedIcon
                                        sx={{
                                            borderRadius: "50%",
                                            padding: "8px",
                                            color: "neutral.navyBlue",
                                            "&:hover": {
                                                // backgroundColor: "neutral.navyBlue",
                                                color: "white",
                                            },
                                        }}
                                    />
                                }
                                sx={{
                                    backgroundColor: "neutral.blueShadeBg",
                                    marginTop: "0.5rem",
                                    color: "grey",
                                    "&:hover": {
                                        backgroundColor: "neutral.blueShadeBg",
                                        color: "gray",
                                        "& .MuiSvgIcon-root": {
                                            backgroundColor: "neutral.teal",
                                            color: "white",
                                        },
                                    },
                                    borderRadius: "14px",
                                    textTransform: "capitalize",
                                    width: "100%",
                                    justifyContent: "flex-start",
                                    fontSize: "16px",
                                }}
                                onClick={handleLogout}
                            >
                                Logout
                            </Button>
                        </Box>
                    </Menu>
                </Box>

            </Toolbar>

            {/* MOBILE DRAWER */}
            <Drawer
                anchor="left"
                open={mobileOpen}
                onClose={toggleMobileMenu}
            >
                <Box width={300} p={2}>
                    <MobileBillingContent onClose={toggleMobileMenu} />
                </Box>
            </Drawer>

            <CustomModal
                customStyles={{ border: "none", minWidth: "50%" }}
                open={appointmentType === "all"}
                onClose={() => setAppointmentType(null)}
                propAppointmentType={appointmentType}
            >
                <AppointmentDetail
                    onClose={() => setAppointmentType(null)}
                    appointments={appointments}
                    propAppointmentType={appointmentType}
                />
            </CustomModal>
            <CustomModal
                customStyles={{ border: "none", minWidth: "50%" }}
                open={appointmentType === "confirmed"}
                onClose={() => setAppointmentType(null)}
                propAppointmentType={appointmentType}
            >
                <AppointmentDetail
                    onClose={() => setAppointmentType(null)}
                    appointments={appointments}
                    propAppointmentType={appointmentType}
                />
            </CustomModal>
            <CustomModal
                customStyles={{ border: "none", minWidth: "50%" }}
                open={appointmentType === "cancelled"}
                onClose={() => setAppointmentType(null)}
                // appointmentType={appointmentType}
                propAppointmentType={appointmentType}
            >
                <AppointmentDetail
                    onClose={() => setAppointmentType(null)}
                    propAppointmentType={appointmentType}
                    appointments={appointments}
                />
            </CustomModal>
            <CustomModal
                customStyles={{ border: "none", minWidth: "70%" }}
                open={openDailyCollection}
                onClose={() => setOpenDailyCollection(false)}
            >
                <DailyCollectionBilling
                    onClose={() => setOpenDailyCollection(false)}
                    appointments={dailyCollection}
                />
            </CustomModal>
        </>
    )
}

export default BillingNavbar;